
const firstTip = {
    images: [
        'First Tip Modal Background',
        'Checkout First Tip Payment Background',
        'Checkout First Tip Payment Background (Thank You)'
    ],
}

module.exports = firstTip;